import React from 'react';

import styled from 'styled-components';
import { StyledBox, StyledTooltip } from 'styles/common';

import AntSwitch from 'uiToolkit/AntSwitch';
import { TogglePraise } from 'uiToolkitV1/ToggleSwitch';

const KudosToggle = ({ selected = false, onChange = () => {} }) => (
  <StyledTooltip title="Comment as a Praise and notify everyone">
    <StyledBox display="flex" alignItems="center">
      <TogglePraise checked={selected} onChange={(e) => onChange(e.target.checked)} />
    </StyledBox>
  </StyledTooltip>
);

const StyledAntSwitch = styled(AntSwitch)`
  transform: scale(0.6);
`;

export default KudosToggle;
